import { render } from "./AvatarCustomization.vue?vue&type=template&id=6699e8b8"
import script from "./AvatarCustomization.vue?vue&type=script&lang=js"
export * from "./AvatarCustomization.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__